import { UXPIN_LINK } from '../enums/enums';

const getUXPinLink = (path) => `${UXPIN_LINK}/${path}`;

export default getUXPinLink;
